// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"faf153ed","234":"258f5321","711":"faf153ed","730":"3529eebd","864":"faf153ed"}[chunkId] + ".chunk.css";
};